import { render, staticRenderFns } from "./Template55_2.vue?vue&type=template&id=6c597e4d&scoped=true&"
import script from "./Template55_2.vue?vue&type=script&lang=js&"
export * from "./Template55_2.vue?vue&type=script&lang=js&"
import style0 from "./Template55_2.vue?vue&type=style&index=0&id=6c597e4d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c597e4d",
  null
  
)

export default component.exports